import { getLocalApi } from "./localApi";
import { Currency } from "app/shared/model";
import apiConfig from "app/api/apiConfig.json";

const pickCurrencyCode = (dto: any): string => {
  const candidates: Array<string | undefined> = [
    dto?.code,
    dto?.currencyCode,
    dto?.isoCode,
    dto?.currencyIsoCode,
    dto?.alpha3Code,
    dto?.alphaCode,
  ].map((value) => (typeof value === "string" ? value.trim() : undefined));

  for (const candidate of candidates) {
    if (candidate && /^[A-Za-z]{3}$/.test(candidate)) {
      return candidate.toUpperCase();
    }
  }

  if (typeof dto?.name === "string") {
    const match = /\(([A-Za-z]{3})\)/.exec(dto.name);
    if (match) return match[1].toUpperCase();
  }

  if (dto?.id && typeof dto.id === "string" && /^[A-Za-z]{3}$/.test(dto.id.trim())) {
    return dto.id.trim().toUpperCase();
  }

  return "";
};

const pickCurrencySymbol = (dto: any): string => {
  const candidates: Array<string | undefined> = [dto?.symbol, dto?.currencySymbol];

  for (const candidate of candidates) {
    if (typeof candidate === "string" && candidate.trim()) {
      return candidate.trim();
    }
  }

  return "";
};

const pickCurrencyName = (dto: any, fallbackCode: string): string => {
  const name = typeof dto?.name === "string" ? dto.name.trim() : "";
  if (name) return name;

  const description = typeof dto?.description === "string" ? dto.description.trim() : "";
  if (description) return description;

  return fallbackCode;
};

export async function getAllCurrencies(): Promise<Currency[]> {
  const localApi = await getLocalApi();

  return await localApi.fetchList(
    apiConfig.reference_data_get_currencies,
    (dto: any) => {
      const code = pickCurrencyCode(dto);
      const idValue = dto?.id ?? dto?.currencyId ?? dto?.currencyID;
      const numericId =
        typeof idValue === "number"
          ? idValue
          : Number.isFinite(Number(idValue))
          ? Number(idValue)
          : 0;

      return {
        id: numericId,
        name: pickCurrencyName(dto, code),
        code,
        symbol: pickCurrencySymbol(dto),
      };
    },
    "Unable to fetch currencies"
  );
}
